// extracted by mini-css-extract-plugin
export var activityContainer = "_fg-0";
export var typingIndicatorContainer = "_fg-1";
export var typingIndicatorDot = "_fg-2";
export var wave = "_fg-3";